import React from "react";
import {useSelector} from "react-redux";
import {fmtDateTime} from "../../../functions/formatDate";
import ETable, {EditIconBtn, YesNoBadge} from "../components/Table";

const TYPE_LABEL = {STRING: "String", INT: "Integer", BOOL: "ANO/NE", JSON: "JSON"};
// Fallback, jen když backend (GET /config/keys) daný klíč nevrátí — jinak je zdrojem
// pravdy label z backendu (ConfigKey enum), ať se popisky časem nerozjedou od sebe.
const CONFIG_KEY_LABEL = {
    "ticketvalidator.pairing_token": "Párovací klíč pro ticket validator (ticketvalidator.pairing_token)",
    "tcp.9876.enabled": "TCP server port 9876 (turnikety/čtečky) povolen",
    "tcp.9878.enabled": "TCP server port 9878 (ticket validator) povolen",
    "udp.9877.enabled": "UDP server port 9877 (Elvis turnikety) povolen",
    "ticketvalidator.server_local_address":"Lokální adresa serveru (ticketvalidator.server_local_address)"
}
const Options = ({row, setEditData}) => {
    return <div style={{display: "flex", gap: "6px", alignItems: "center"}}>
        <EditIconBtn onClick={() => setEditData(row)}/>
    </div>
}

// Vykreslení sloupce "Hodnota" podle valueType — BOOL jako badge, JSON jako čitelný
// odsazený blok (se scrollem, ať dlouhý JSON nerozbije výšku řádku), zbytek prostý text.
const ConfigValueCell = ({row}) => {
    if (row.value == null || row.value === "") {
        return <span style={{color: "#94a3b8"}}>—</span>;
    }
    if (row.valueType === "BOOL") {
        return <YesNoBadge value={row.value === "true" || row.value === true}/>;
    }
    if (row.valueType === "JSON") {
        let pretty;
        try {
            pretty = JSON.stringify(JSON.parse(row.value), null, 2);
        } catch (e) {
            // Nevalidní JSON v DB (např. ruční zásah v Admineru) nesmí shodit celou tabulku —
            // ukaž syrovou hodnotu a dej najevo, že se nepodařilo naparsovat.
            return (
                <div>
                    <div style={{color: "#dc2626", fontSize: "var(--enigoo-fs-xs)", marginBottom: "2px"}}>
                        Nevalidní JSON
                    </div>
                    <span style={{fontFamily: "monospace", fontSize: "var(--enigoo-fs-sm)", wordBreak: "break-word"}}>
                        {row.value}
                    </span>
                </div>
            );
        }
        return (
            <pre style={{
                margin: 0,
                maxHeight: "160px",
                maxWidth: "420px",
                overflow: "auto",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontFamily: "monospace",
                fontSize: "var(--enigoo-fs-sm)",
                background: "#f8fafc",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                padding: "6px 8px",
            }}>
                {pretty}
            </pre>
        );
    }
    return <span style={{wordBreak: "break-word"}}>{row.value}</span>;
};

const ConfigTable = ({data, setData, configKeys, setEditData}) => {
    const user = useSelector((state) => state.user);
    const backendLabelByKey = Object.fromEntries((configKeys ?? []).map(k => [k.key, k.label]));
    const labelFor = (configKey) => backendLabelByKey[configKey] ?? CONFIG_KEY_LABEL[configKey] ?? configKey;

    const columns = [
        {header: "ID", key: "id"},
        {header: "Název", render: row => labelFor(row.configKey)},
        {header: "Hodnota", render: row => <ConfigValueCell row={row}/>},
        {header: "Typ", render: row => TYPE_LABEL[row.valueType] ?? "-"},
        {header: "Popis", key: "description"},
        {header: "Poslední úprava", render: row => fmtDateTime(row.updatedAt)},
        {
            header: "Možnosti", render: row => (
                <Options row={row} setEditData={setEditData}/>
            )
        },
    ]
    return <>
        <ETable columns={columns} data={data}/>

    </>
}
export default ConfigTable;
